export enum OrganizationUserType {
  NONE = "",
  EMPLOYED = "EMPLOYED", // 모비우스 재직자
  JOB_SEEKER = "JOB_SEEKER" // 모비우스 구직자
}

export enum OrganizationUserText {
  "" = "-",
  EMPLOYED = "재직자", // 모비우스 재직자
  JOB_SEEKER = "구직자" // 모비우스 구직자
}
